module.exports = __webpack_public_path__ + "static/media/IlotA_mall_2.c4c4576a.webp";